import React, { useState } from "react";
import { Filter } from "lucide-react";

export const Search = ({ onSearch, onFilter }) => {
  const [query, setQuery] = useState("");
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const applyFilters = () => {
    // Ensure onFilter is a function before calling
    if (onFilter && typeof onFilter === 'function') {
      onFilter({ dateFrom, dateTo });
    }
    setFilterOpen(false);
  };

  const clearFilters = () => {
    setDateFrom("");
    setDateTo("");
    
    // Ensure onFilter is a function before calling
    if (onFilter && typeof onFilter === 'function') {
      onFilter({ dateFrom: "", dateTo: "" });
    }
    setFilterOpen(false);
  };

  return (
    <div className="relative">
      <div className="flex gap-2 items-center">
        <input
          type="text"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            onSearch(e.target.value);
          }}
          placeholder="Search..."
          className="border rounded px-3 py-2"
        />
        <button
          onClick={() => setFilterOpen(!isFilterOpen)}
          className="bg-gray-300 p-2 rounded hover:bg-gray-400"
        >
          <Filter size={20} />
        </button>
      </div>

      {isFilterOpen && (
        <div className="absolute top-full mt-2 bg-white p-4 shadow rounded w-80 z-50">
          <h3 className="font-semibold mb-4">Filter Options</h3>
          <div className="flex flex-col gap-3">
            <label>
              From Date:
              <input
                type="date"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
                className="border p-2 rounded w-full"
              />
            </label>
            <label>
              To Date:
              <input
                type="date"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
                className="border p-2 rounded w-full"
              />
            </label>
          </div>
          <div className="flex justify-end mt-4 gap-2">
            <button
              onClick={clearFilters}
              className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
            >
              Clear
            </button>
            <button
              onClick={() => setFilterOpen(false)}
              className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            >
              Cancel
            </button>
            <button
              onClick={applyFilters}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              disabled={!dateFrom || !dateTo}
            >
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};